import { Session } from './session';
import { z } from 'zod';

export const FinalSessionEvent = z.intersection(
    z.object({
        eventId: z.string(),
        createdOn: z.coerce.date(),
        modifiedOn: z.coerce.date(),
    }),
    z.discriminatedUnion('type', [
        z.object({
            type: z.literal('unknownBarcode'),
            properties: z.object({
                code: z.string().nullish(),
                codeType: z.string().nullish(),
                count: z.string().nullish(),
                keep: z.literal(['true', 'false']).nullish(),
            }),
        }),
        z.object({
            type: z.literal('parallelSessionLogin'),
            properties: z.object({
                createdOn: z.coerce.date().nullish(),
                sessionGuid: z.string().nullish(),
                storeGuid: z.string().nullish(),
                cartId: z.string().nullish(),
            }),
        }),
        z.object({
            type: z.literal('customerCardScan'),
            properties: z.object({
                code: z.string().nullish(),
                type: z.string().nullish(),
                excludeFromSession: z.literal(['True', 'False']).nullish(),
                notifyPosService: z.literal(['True', 'False']).nullish(),
                showDialogToCustomer: z.literal(['True', 'False']).nullish(),
            }),
        }),
        z.object({
            type: z.literal('sessionReopen'),
            properties: z.object({
                reason: z.unknown().nullish(),
            }),
        }),
        z.object({
            type: z.literal('sessionTransfer'),
            properties: z.object({
                sourceCartId: z.string().nullish(),
            }),
        }),
    ]),
);
export type FinalSessionEvent = z.infer<typeof FinalSessionEvent>;

export const FinalSession = Session.extend({
    events: FinalSessionEvent.array().nullish(),
});
export type FinalSession = z.infer<typeof FinalSession>;
